import { findParentUntilMultipleChildren, isImageSource, restoreOriginalImageSrc } from "../utils";

export default function getClickAbleDom(selector) {
    if (!selector) return null;
    let clickableItem = document.querySelector(isImageSource(selector) ? `img[src="${selector}"]` : selector.includes("#") || selector.includes(".") ? selector : `.${selector}`);
    if (isImageSource(selector)) {
        if (!clickableItem) {
            clickableItem = document.querySelector(`img[data-src="${selector}"]`);
        }

        if (!clickableItem) {
            clickableItem = document.querySelector(`img[data-src="${restoreOriginalImageSrc(selector)}"]`);
        }

        if (!clickableItem) {
            clickableItem = document.querySelector(`img[src="${restoreOriginalImageSrc(selector)}"]`);
        }

        if (!clickableItem) {
            clickableItem = document.querySelector(`a[href="${restoreOriginalImageSrc(selector)}"]`);
        }
    }

    if (clickableItem) {
        clickableItem = findParentUntilMultipleChildren(clickableItem);
        if (clickableItem?.innerHTML?.includes("<a")) {
            clickableItem.classList.add("bp3dv_a_popup_opener");
        }

        if (clickableItem?.innerHTML?.includes("<img") && window.location.host === "reintest.be") {
            clickableItem.classList.add("bp3dv_play_icon");
        }
    }
    return clickableItem;
}